<template>
    <back-to-top class="back-to-top" right="30px" visibleoffset="1400">
        <div class="back-to-top__circle">
            <span class="icon-arrow-up"></span>
        </div>
    </back-to-top>
</template>

<script>
    import BackToTop from 'vue-backtotop'

    export default {
        name: 'totem-back-to-top',
        components: {
            BackToTop
        }
    }
</script>

<style lang="scss" scoped>
    .back-to-top {
        bottom: 435px !important;
        z-index: 2;

        [class*="desktop"] & {
            bottom: 340px !important;
        }

       &__circle {
           display: flex;
           justify-content: center;
           align-items: center;
           background: $orange;
           height: 50px;
           width: 50px;
           border-radius: 100%;
       }
    }
    .icon-arrow-up {
        color: $white;
        font-size: 2rem;
    }
</style>
